export default {"src":"/hedera/_next/static/media/hederaLight.3b01ad6e.svg","height":56,"width":56};